var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { ViewMode } from '../../models/view-mode.enum';
import { ViewActions } from '../../state/view.actions';
import { ViewState } from '../../state/view.state';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Fullscreen } from 'src/app/shared/libraries/fullscreen/fullscreen';
import { ViewService } from '../../view.service';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { EngineState } from 'src/app/engine/state/engine.state';
import { ViewLayoutStatus } from '../../models/view-layout-status.enum';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { HistoryService } from 'src/app/history/history.service';
var MenuModeStatus;
(function (MenuModeStatus) {
    MenuModeStatus[MenuModeStatus["Opened"] = 0] = "Opened";
    MenuModeStatus[MenuModeStatus["Closed"] = 1] = "Closed";
    MenuModeStatus[MenuModeStatus["Reset"] = 2] = "Reset";
})(MenuModeStatus || (MenuModeStatus = {}));
var ViewMenuComponent = /** @class */ (function () {
    // ---------- Lifecycle Hooks ----------
    function ViewMenuComponent(store, viewService, layoutService, historyService, changeDetectorRef) {
        this.store = store;
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.historyService = historyService;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Class Variables ----------
        this.open = false;
        this.canReset = false;
        this.menuMode = MenuModeStatus.Closed;
        this.menuModeStatus = MenuModeStatus;
        this.viewMode = ViewMode;
        this.viewLayout = ViewLayout;
        this.canFullscreen = true;
        this.ngUnsubscribe = new Subject();
    }
    ViewMenuComponent.prototype.ngOnInit = function () {
        this.canFullscreen = Fullscreen.canFullscreen();
        this.initLayoutListener();
    };
    ViewMenuComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ViewMenuComponent.prototype.initLayoutListener = function () {
        var _this = this;
        this.store.select(ViewState.getLayout)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (layout) {
            var drawerMode = _this.viewService.inferDrawerMode(layout);
            var menuMode = (drawerMode !== ViewMode.Content || layout.search.status === ViewLayoutStatus.Show) ?
                MenuModeStatus.Reset : MenuModeStatus.Closed;
            _this.toggleMenu(menuMode);
        });
    };
    ViewMenuComponent.prototype.handleMenuClick = function (menuMode) {
        this.toggleMenu(menuMode);
    };
    ViewMenuComponent.prototype.handleSearchClick = function () {
        this.toggleMenu(MenuModeStatus.Reset);
        this.viewService.toggleSearch();
    };
    ViewMenuComponent.prototype.handleToolsClick = function () {
        this.toggleMenu(MenuModeStatus.Reset);
        var layout = this.store.selectSnapshot(ViewState.getLayout);
        layout.tools.status = ViewLayoutStatus.Show;
        this.store.dispatch(new ViewActions.SetLayout(layout));
    };
    ViewMenuComponent.prototype.handleFullscreenClick = function () {
        this.closeMenu();
        Fullscreen.toggleFullscreen();
    };
    ViewMenuComponent.prototype.handlePresentationClick = function () {
        this.closeMenu();
        this.viewService.togglePresentation();
    };
    ViewMenuComponent.prototype.handleHelpClick = function () {
        this.closeMenu();
        this.viewService.toggleHelp();
    };
    ViewMenuComponent.prototype.handleNewTabClick = function () {
        this.viewService.openInNewTab();
    };
    ViewMenuComponent.prototype.handleToggleLabelsClick = function () {
        this.viewService.toggleLabels();
    };
    ViewMenuComponent.prototype.handleResetMenuClick = function () {
        this.closeMenu();
        this.viewService.resetLayout();
    };
    ViewMenuComponent.prototype.handleResetSceneClick = function () {
        this.historyService.resetChapter();
    };
    ViewMenuComponent.prototype.closeMenu = function () {
        this.toggleMenu(MenuModeStatus.Closed);
    };
    ViewMenuComponent.prototype.toggleMenu = function (menuMode) {
        if (menuMode == null) {
            menuMode = this.menuMode === MenuModeStatus.Closed ? MenuModeStatus.Opened : MenuModeStatus.Closed;
        }
        this.menuMode = menuMode;
        this.changeDetectorRef.markForCheck();
    };
    ViewMenuComponent.prototype.isEnabled = function (layout) {
        return this.layoutService.isLayoutEnabled(layout);
    };
    __decorate([
        Select(StoryLabelsState.getChapterLabels),
        __metadata("design:type", Observable)
    ], ViewMenuComponent.prototype, "labels$", void 0);
    __decorate([
        Select(EngineState.getShowLabels),
        __metadata("design:type", Observable)
    ], ViewMenuComponent.prototype, "showLabels$", void 0);
    return ViewMenuComponent;
}());
export { ViewMenuComponent };
